import React from 'react';
import ReactDOM from 'react-dom/client';
import Regelverkstolkninger from './Components/Regelverkstolkninger/Regelverkstolkninger';
import setupHeaderAndFooter, {SearchSite} from './utils/setupHeaderAndFooter';
import 'udirsok-index.js'

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render( <Regelverkstolkninger/> );

setupHeaderAndFooter(SearchSite.Regelverk);
